import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import http from "../Utils/axiosConfig";
import { apiMessage } from "../Utils/apiMessage";

const LoginForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    userName: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(""); // API error message
  const [loading, setLoading] = useState(false); // optional loading state
  const [showPassword, setShowPassword] = useState(false);

  // ✅ Redirect to dashboard if already logged in
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("isAuthenticated");
    if (isAuthenticated) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setApiError(""); // reset API error
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.userName.trim()) newErrors.userName = "Username is required";
    if (!formData.password.trim()) newErrors.password = "Password is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const res = await http.post('login/authenticate', {
        username: formData.userName,
        password: formData.password,
      });

      if (res.code === "LOGIN_SUCCESSFULLY") {
        const userData = res.data;

        // store user data
        localStorage.setItem("dairy_name", userData.mr_name);
        localStorage.setItem("temp_key", userData.id);

        // ✅ store auth flag
        localStorage.setItem("isAuthenticated", "true");

        // redirect
        navigate("/dashboard", { replace: true });
      } else {
        setApiError(apiMessage(res, "लॉगिन अयशस्वी"));
      }
    } catch (err) {
      console.error("Login error:", err);
      setApiError(apiMessage());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lgform">
      <img src="/logo.png" alt="Logo" className="logo" />
      {/* <h3 className="heading">DairyMitra</h3> */}
      <form onSubmit={handleSubmit}>
        <div className="login-form">
          <h2>Admin Login</h2>
          <label className="label">User Name</label>
          <input
            type="text"
            name="userName"
            placeholder="Enter valid User Name"
            value={formData.userName}
            onChange={handleChange}
          />
          {errors.userName && (
            <p className="error error-input">{errors.userName}</p>
          )}

          <label className="label">Password</label>
          <div className="password-field-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter valid Password"
              value={formData.password}
              onChange={handleChange}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              tabIndex={-1}
            >
              <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
            </button>
          </div>
          {errors.password && (
            <p className="error error-input">{errors.password}</p>
          )}
          {apiError && <div className="login-error-banner">{apiError}</div>}
          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </div>
      </form>

      <div className="login-contact">
        <p className="login-contact-label">Need help? Contact support</p>
        <div className="login-contact-links">
          <a href="tel:+919324443237" className="login-contact-link">
            <i className="fa-solid fa-phone"></i> +91 93244 43237
          </a>
          <a href="tel:+919920898976" className="login-contact-link">
            <i className="fa-solid fa-phone"></i> +91 99208 98976
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
